import React, { Fragment, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Col, Row, Button, Form, FormGroup } from 'reactstrap';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { useAuth } from '../../Context/Auth/AuthContext';
import { toast } from 'react-toastify';
import Strings from '../../translations/Translations';
import WAM from '../../services/WAM';

const schema = Yup.object().shape({
  username: Yup.string().required(Strings('email_username_is_required')),
});

export default function ForgotPassword() {
  const { register, errors, handleSubmit, reset } = useForm({
    validationSchema: schema,
  });
  const { toggleLoading } = useAuth();
  const history = useHistory();

  const onSubmit = useCallback(async (data) => {
    toggleLoading(true);
    const { username } = data;
    
    try {
      const response = await WAM.forgot(username);

      toggleLoading(false);

      if (response.result === 'success') {
        toast.success(Strings('a_new_password_has_been_send_to_your_email'));
        reset();
        history.replace('/');
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_forgot_password_request');
        toast.error(message);
      }
    } catch (err) {
      toggleLoading(false);
      toast.error(Strings('general_error'));
    }
  }, [toggleLoading, reset, history]);

  return (
    <Fragment>
      <div className="h-100 bg-animation">
        <div className="d-flex h-100 justify-content-center align-items-center">
          <Col md="6" className="mx-auto app-login-box">

            <div className="modal-dialog w-100">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="h5 modal-title">
                    {Strings('forgot_your_password')}
                  </div>
                </div>
                <div className="modal-body">
                  <div>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                      <Row form>
                        <Col md={12}>
                          <FormGroup>
                            <input
                              type="text"
                              name="username"
                              id="username"
                              placeholder={Strings('username_email')}
                              ref={register}
                              className="form-control"
                            />
                            {errors.username && (
                              <p className="error-validation text-left">
                                {errors.username.message}
                              </p>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                  <h6 className="mb-0 mt-2">
                    <Link className="text-primary" to="/">
                      {Strings('return_to_login')}
                    </Link>
                  </h6>
                </div>
                <div className="modal-footer clearfix">
                  <div className="float-right">
                    <Button
                      color="primary"
                      size="lg"
                      onClick={handleSubmit(onSubmit)}
                    >
                      {Strings('recover_password')}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center opacity-8 mt-3">
              Copyright &copy; Photozig Inc.
            </div>
          </Col>
        </div>
      </div>
    </Fragment>
  );
}
